module.exports = __webpack_public_path__ + "img/170820.42c76553.png";